import { render } from "./SaveCompleted.vue?vue&type=template&id=82bedd66"
import script from "./SaveCompleted.vue?vue&type=script&lang=js"
export * from "./SaveCompleted.vue?vue&type=script&lang=js"

import "./SaveCompleted.vue?vue&type=style&index=0&id=82bedd66&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__